export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
     * @description 参数列表
     * @description http://yapi.xiya.vip/project/11/interface/api/75
     */
    CONFIG_ALL: function CONFIG_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/configs/index',
        method: 'post',
        data: query
      });
    },

    /**
     * @description 参数列表 获取前端或者后端使用的参数列表 无分页
     * @description http://yapi.xiya.vip/project/11/interface/api/620
     */
    CONFIG_FIND: function CONFIG_FIND() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return request({
        url: '/api/configs/find_all',
        method: 'post',
        data: {
          type: type
        }
      });
    },

    /**
     * @description 参数创建
     * @description http://yapi.xiya.vip/project/11/interface/api/80
     */
    CONFIG_CREATE: function CONFIG_CREATE(data) {
      return request({
        url: '/api/configs/create',
        method: 'put',
        data: data
      });
    },

    /**
     * @description 参数详情
     * @description http://yapi.xiya.vip/project/11/interface/api/95
     */
    CONFIG_DETAIL: function CONFIG_DETAIL(id) {
      return request({
        url: '/api/configs/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
     * @description 参数编辑
     * @description http://yapi.xiya.vip/project/11/interface/api/95
     */
    CONFIG_UPDATE: function CONFIG_UPDATE(data) {
      return request({
        url: '/api/configs/update',
        method: 'put',
        data: data
      });
    },

    /**
     * @description 参数删除
     * @description http://yapi.xiya.vip/project/11/interface/api/90
     */
    CONFIG_DELETE: function CONFIG_DELETE(id) {
      return request({
        url: '/api/configs/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    }
  };
});